
export function requiredTextAfterAttempt (name, failedLabel, successLabel = '', attemptProperty = 'attempted') {
  return (state) => {
    const attempted = state[attemptProperty]
    if (!attempted) return successLabel
    const value = state[name]
    return value && value.length > 0 ? successLabel : failedLabel
  }
}
